var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserEdited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ai-Manual"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.42604 22.9798L5.38092 26.1196L12.7822 33.7569C12.9092 33.8879 13.0717 33.9813 13.245 34.0261L8.42604 22.9798ZM8.42604 22.9798L15.7845 30.5729L15.7847 30.5732C15.9152 30.7076 16.0088 30.8756 16.0549 31.069L16.0557 31.0726L16.9934 34.9462L16.9944 34.9506C16.9974 34.9628 16.9965 34.9713 16.995 34.9771C16.9938 34.9814 16.992 34.9855 16.989 34.9896L13.2454 34.0262L8.42604 22.9798ZM20.8813 33.9729L20.8823 33.9773C20.9631 34.3175 21.0001 34.6606 20.9962 35H38.1435C38.5877 35 39 34.6196 39 34.0857C39 28.2603 34.4308 23.5938 28.8545 23.5938H23.1474C20.7635 23.5938 18.5751 24.4421 16.8399 25.8687L18.6394 27.7241C19.2772 28.3818 19.7272 29.199 19.9439 30.1005C19.944 30.1007 19.944 30.1008 19.944 30.1009L20.8813 33.9729ZM21.0579 16.3874C22.3734 17.7438 24.151 18.5 25.9978 18.5C27.8446 18.5 29.6222 17.7438 30.9377 16.3874C32.2542 15.03 32.9991 13.1825 32.9991 11.25C32.9991 9.31747 32.2542 7.47002 30.9377 6.11257C29.6222 4.75616 27.8446 4 25.9978 4C24.151 4 22.3734 4.75616 21.0579 6.11257C19.7414 7.47002 18.9966 9.31747 18.9966 11.25C18.9966 13.1825 19.7414 15.03 21.0579 16.3874ZM4.45394 18.8901C4.45354 18.8897 4.45314 18.8893 4.45274 18.8889C3.8624 18.2854 2.93001 18.2891 2.34935 18.8878L1.45143 19.8136C1.45103 19.814 1.45063 19.8145 1.45024 19.8149C0.848328 20.4408 0.851852 21.4556 1.44921 22.0716L2.56915 23.2263L5.61429 20.0865L4.45394 18.8901Z",
    stroke: "#3D4B59",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEdited);
export default __webpack_public_path__ + "static/media/user_edited.ebdebc91.svg";
export { ForwardRef as ReactComponent };